import { adminAllStoragePoolsQueryAtom } from "@/admin/buckets/storagePoolsQuery.ts";
import { type AdminHostWithType, adminAllHostsQueryAtom } from "@/admin/hosts/hostQuery.ts";
import { mergeLoadedQueries } from "@/utils/query/mergeQueries.ts";
import { atom } from "jotai/vanilla";

export interface HostWithStorage extends AdminHostWithType {
    storage_pool_name: string;
}

export const allHostsWithStorageQueryAtom = atom((get) =>
    mergeLoadedQueries(
        {
            hosts: get(adminAllHostsQueryAtom),
            pools: get(adminAllStoragePoolsQueryAtom),
        },
        ({ hosts, pools }) =>
            [...hosts.values()].map(
                (h): HostWithStorage => ({
                    ...h,
                    // Join storage pool to host
                    storage_pool_name: h.storage_pool_uuid
                        ? (pools.get(h.storage_pool_uuid)?.display_name ?? "<missing>")
                        : "-",
                }),
            ),
    ),
);
